import React from 'react';
import './AdminButton.css';

/**
 * @param {{
 *   variant?: 'primary' | 'secondary' | 'ghost' | 'danger',
 *   size?: 'sm' | 'md',
 *   icon?: React.ReactNode,
 *   loading?: boolean,
 *   disabled?: boolean,
 *   children?: React.ReactNode,
 *   className?: string
 * } & React.ButtonHTMLAttributes<HTMLButtonElement>} props
 */
function AdminButton({
  variant = 'secondary',
  size = 'md',
  icon = null,
  loading = false,
  disabled = false,
  children,
  className = '',
  type = 'button',
  ...rest
}) {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      className={`au-button au-scope au-button--${variant} au-button--${size}${loading ? ' is-loading' : ''}${className ? ` ${className}` : ''}`}
      disabled={isDisabled}
      aria-busy={loading}
      {...rest}
    >
      {loading ? (
        <span className="au-button__loading" aria-hidden="true">
          <span className="au-button__dot">.</span>
          <span className="au-button__dot">.</span>
          <span className="au-button__dot">.</span>
        </span>
      ) : (
        <>
          {icon ? <span className="au-button__icon" aria-hidden="true">{icon}</span> : null}
          {children ? <span className="au-button__label">{children}</span> : null}
        </>
      )}
    </button>
  );
}

export default AdminButton;
